import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Home from "@/pages/Home";
import Metronome from "@/pages/Metronome";
import ColorTrainer from "@/pages/ColorTrainer";
import ColorNumberTrainer from "@/pages/ColorNumberTrainer";
import MathTrainer from "@/pages/MathTrainer";
import Arrows4Page from "@/pages/Arrows4Page";
import Arrows8Page from "@/pages/Arrows8Page";
import Tutorial from "@/pages/Tutorial";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/metronome" element={<Metronome />} />
          <Route path="/colors" element={<ColorTrainer />} />
          <Route path="/colors-numbers" element={<ColorNumberTrainer />} />
          <Route path="/math" element={<MathTrainer />} />
          <Route path="/arrows" element={<Arrows4Page />} />
          <Route path="/arrows-diag" element={<Arrows8Page />} />
          <Route path="/tutorial" element={<Tutorial />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
